import React from 'react';
import { MapStatsUtil } from '../../../../utils/map_stats_util';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const SplitsTab = createReactClass({
  formatNumber(data, precision, measurementUnit, asPlainText) {
    // Cannot use toLocaleString() to format thousands because it does not work in prerender
    if (data) {
      let result = data.toFixed(precision).toString();
      const decimal_length = precision == 0 ? 0 : 2;
      if (data >= 1000000)
        result = `${result.substr(0, result.length - 6 - decimal_length)},${result.substr(-6 - decimal_length, 3)},${result.substr(
          -3 - decimal_length
        )}`;
      else if (data >= 1000) result = `${result.substr(0, result.length - 3 - decimal_length)},${result.substr(-3 - decimal_length)}`;
      if (asPlainText) return `${result} ${measurementUnit}`;
      return (
        <span>
          {result}
          <span className="stats-unit">{measurementUnit}</span>
        </span>
      );
    }

    return asPlainText ? (
      `0 ${measurementUnit}`
    ) : (
      <span>
        0<span className="stats-unit">{measurementUnit}</span>
      </span>
    );
  },
  renderSplitItem(split, metric, displaySpeed) {
    return (
      <tr>
        <td>{split.distance.toFixed(1)}</td>
        <td>{displaySpeed ? split.avg_speed.toFixed(2).toString() : MapStatsUtil.secondsToTimeNo24HourLimit(split.pace)}</td>
        <td className="split-bar">
          <div style={{ width: `${split.bar * 100}%` }} />
        </td>
        <td>{this.formatNumber(split.elevation, 0, metric ? ' m' : ' ft')}</td>
      </tr>
    );
  },
  render() {
    const { displayMetric } = this.props;
    const displaySpeed = this.props.currentUser && this.props.currentUser.displaySpeed;
    const paceSpeedTitle = displaySpeed ? StringConstantsMixin.strings.STATS.NORMAL.AVG_SPEED : StringConstantsMixin.strings.STATS.NORMAL.PACE;
    let { splits } = this.props;
    if (!this.props.splits) return null;
    splits = displayMetric ? splits.metric : splits.imperial;
    const splitsRows = splits.map(
      function(split) {
        return this.renderSplitItem(split, displayMetric, displaySpeed);
      }.bind(this)
    );
    const showSource = this.props.currentUser && this.props.currentUser.admin && this.props.source;
    return (
      <div id="splits" className={StringConstantsMixin.constants.XLATE.NONE}>
        <div className="action-bar">
          <menu className="title clearfix overview-menu tabs inline-menu">
            <li className="active">
              <h3>{StringConstantsMixin.strings.STATS.NORMAL.SPLITS + (showSource ? ` - ${this.props.source}` : '')}</h3>
            </li>
          </menu>
        </div>
        <div className="splits-table">
          <table>
            <thead>
              <tr>
                <th>{displayMetric ? StringConstantsMixin.strings.STATS.NORMAL.KILOMETERS : StringConstantsMixin.strings.STATS.NORMAL.MILES}</th>
                <th>{paceSpeedTitle}</th>
                <th className="split-bar" />
                <th>{StringConstantsMixin.strings.STATS.NORMAL.ELEV_GAIN}</th>
              </tr>
            </thead>
            <tbody>{splitsRows}</tbody>
          </table>
        </div>
      </div>
    );
  }
});

export { SplitsTab };
